import React, { useState } from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';
import { truncate } from 'lib/helpers/string-manipulators';

const Container = styled.div`
  height: 38px;
  padding-right: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const LabelDiv = styled.div<{ background: string }>`
  background: ${props => props.background};
  border-color: ${props => props.background};
  border-radius: 2px;
  min-height: 32px;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
const StyledCheckbox = styled.div<{ active: boolean; color: string }>`
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: ${props => (props.active ? props.color : 'white')};
  border: 1px solid ${props => props.color};
  border-radius: 2px;
  margin: 8px;
  transition: all 150ms;

  :hover {
    cursor: pointer;
  }

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px ${props => props.color};
  }

  ${Icon} {
    visibility: ${props => (props.active ? 'visible' : 'hidden')};
  }
`;

const Text = styled.span`
  line-height: 14px;
  font-size: 12px;
  font-weight: 500;
  color: ${colors.fontBody};
  margin-right: 8px;
  position: relative;
  top: -3px;
`;

const Subtext = styled.p`
  font-size: 12px;
  margin-top: 8px;
  margin-left: 16px;
  width: 0px; // We do not want the button spacing to change just because the subtext is long.
  white-space: nowrap;
  color: ${colors.globalIcon};
`;

export interface IBubblyButtonProps {
  color?: string;
  background?: string;
  text: string;
  subtext?: string;
  active: boolean;
  onClick: () => void;
  onHover?: () => void;
  onBlur?: () => void;
}

export default ({
  color = colors.primary,
  background = colors.background,
  text,
  subtext,
  active,
  onClick,
  onHover,
  onBlur,
}: IBubblyButtonProps) => {
  const [showSubtext, setShowSubtext] = useState(false);

  const setFocus = () => {
    setShowSubtext(true);
    if (onHover) {
      onHover();
    }
  };

  const unsetFocus = () => {
    setShowSubtext(false);
    if (onBlur) {
      onBlur();
    }
  };

  return (
    <Container>
      <LabelDiv background={background}>
        <HiddenCheckbox color={color} />
        <StyledCheckbox
          color={color}
          active={active}
          onClick={onClick}
          onFocus={setFocus}
          onBlur={unsetFocus}
          onMouseOver={setFocus}
          onMouseOut={unsetFocus}
          data-testid="bubbly-text-checkbox"
        >
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
        <Text>{text}</Text>
      </LabelDiv>
      {subtext && showSubtext ? <Subtext>{truncate(subtext, { maxLength: 60 })}</Subtext> : null}
    </Container>
  );
};
